import { StyleSheet } from 'react-native';
import { Colors } from '../../../themes/colors';

export const routineMessageStyles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'column',
  },
  messageTitle: {
    fontSize: 16,
    fontWeight: '500',
    color: Colors.role.textSecondary,
  },
  questionContainer: {
    marginVertical: 5,
    borderRadius: 8,
    padding: 12,
  },
  exceptionsContainer: {
    backgroundColor: Colors.redBackground,
  },
  noExceptionsContainer: {
    backgroundColor: Colors.role.surfaceHover,
  },
  isEdited: {
    backgroundColor: Colors.primaryLight,
    borderWidth: 1,
    borderColor: Colors.primary,
  },
  isEditedText: {
    color: Colors.primary,
  },
  questionLabel: {
    color: Colors.role.textSecondary,
  },
  questionLabelException: {
    color: Colors.redText,
  },
  text: {
    color: Colors.role.textSecondary,
  },
  textException: {
    color: Colors.redText,
  },
});
